const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("./charts/ItinerariesByDestination"),
    name: "Itineraries by Destination",
    accessSetting: "home_screen:itineraries_by_destination",
    visible: true,
    props: {},
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("./charts/ItinerariesByStaff"),
    name: "Itineraries By Staff",
    accessSetting: "home_screen:itineraries_by_staff",
    visible: true,
    props: {},
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("./charts/SalesByStaff"),
    name: "Sales By Staff",
    accessSetting: "home_screen:sales_by_staff",
    visible: true,
    props: {},
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("./charts/SalesByAgent"),
    name: "Sales By Agent",
    accessSetting: "home_screen:sales_by_agent",
    visible: true,
    props: {},
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/dashboard/dashboard-charts.js